import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";

/**
 * Retrieve the configurations governing a district's restrictions of its students being able to search.
 */
const useStudentSearchRestrictionsGet = () => {
  const requestUrl = `${MONOLITH_ORIGIN}/api/v3/visibility/content-settings-search-message/`;
  return useRestQuery(requestUrl);
};

export default useStudentSearchRestrictionsGet;
